import React from 'react';
import { useAppSelector } from "src/store/hooks";

import { Spin } from "antd";
import Pagination from 'src/componets/Pagination';

import '../style.scss';
import { EntityId } from "@reduxjs/toolkit";
import Card from "../../../mine_craft/Assets/_partials/_Card";
import { selectAssetEntities, selectAssetIds } from "../../../../store/mine_craft/assetsSlice";
import Edit from "../Edit";

interface propsInterface {
  limit: number;
  pagination: boolean;
}

const _List = ({ limit, pagination }: propsInterface) => {
  const count  = useAppSelector(state => state.mineCraft.assets.count);
  const error  = useAppSelector(state => state.mineCraft.assets.error);
  const status = useAppSelector(state => state.mineCraft.assets.status);
  const ids = useAppSelector(selectAssetIds);
  const assets = useAppSelector(selectAssetEntities);

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  const renderAsset = (id: EntityId) => {
    const asset = assets[id];

    if (!asset) {
      return;
    }

    return <Card asset={asset} key={`asset-${id}`} />;
  }

  return (
    <>
      {ids && ids.map(renderAsset)}

      {pagination && <Pagination total={count} size={limit} />}

      <Edit />
    </>
  );
}

export default _List;
